import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProfessionalTagsListComponent } from './professional-tags-list/professional-tags-list.component';
import { RenderersModule } from 'src/app/shared/renderers/renderers.module';
import { ProfessionalTagsFormComponent } from './professional-tags-form/professional-tags-form.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    ProfessionalTagsListComponent,
    ProfessionalTagsFormComponent
  ],
  imports: [
    CommonModule,
    RenderersModule,
    SharedModule,
    ReactiveFormsModule
  ]
})
export class ProfessionalTagsModule { }
